import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAllNodes, selectFilteredPoints } from './slice/mapSelectors';
import { fromLonLat } from 'ol/proj';
import { useMapLayer } from '../hooks/useMapLayer';
import { FeatureLike } from '../utils/geoJsonUtils';
import { selectShowNoticeComponents } from '../plotter/plotterSelectors';

const PUBLIC_FOLDER = process.env.PUBLIC_URL;

const getStyle = () => {
  return {
    'icon-src': `${PUBLIC_FOLDER}/marker-icon-2x.png`,
    'icon-scale': 0.4,
    'icon-displacement': [0, 16],
  };
};

export type MapNoticeComponentsProps = {
  zIndex: number;
};

export const MapNoticeComponents: React.FC<MapNoticeComponentsProps> = ({
  zIndex,
}) => {
  const points = useSelector(selectFilteredPoints);
  const nodes = useSelector(selectAllNodes);
  const showNoticeComponents = useSelector(selectShowNoticeComponents);

  const _features = useMemo<FeatureLike[]>(
    () =>
      Object.values(points)
        .filter((point) => point.notice_components?.length > 0)
        .map((point) => {
          const node = point.node ? nodes[point.node] : null;
          return node;
        })
        .filter(Boolean)
        .map((node) => {
          const coordinates = fromLonLat([node?.lng, node?.lat].map(Number));
          return {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates,
            },
            properties: {
              id: node?.id,
              key: `node-${node?.id}`,
            },
          };
        }),
    [points, zIndex],
  );

  const features = useMemo<FeatureLike[]>(() => {
    if (showNoticeComponents) {
      return _features;
    }
    return [];
  }, [showNoticeComponents, _features]);

  const style = useMemo(() => getStyle(), []);

  useMapLayer(features, { zIndex, style });

  return <></>;
};
